// common/src/other/driverEligibility.js
//
// SINGLE SOURCE OF TRUTH for driver document verification + dispatch eligibility.
// Pure module (NO firebase / redux / RN imports) so it is safely shared by:
//   - common redux actions  (fetchDrivers gate -> usersactions.js)
//   - mobile onboarding state machine (onboardingState.js)
//   - mobile driver screens (DriverTrips, MapScreen)
//
// IMPORTANT: Cloud Functions live in a separate package (functions/) that CANNOT
// import this RN 'common' package. functions/ keeps a MIRRORED copy of
// REQUIRED_DRIVER_DOCS + areDocsVerified in its dispatch gate (functions/index.js).
// If you change the list or logic here, update the functions copy in the same PR.
//
// K8 (2026-05-28): replaced the legacy exicube gate
// (approved + driverActiveStatus + licenseImage + carApproved + term) with the
// Faz A document-verification model below.

export const REQUIRED_DRIVER_DOCS = ['registration', 'insurance', 'psvBadge'];

// True when every required driver document has been verified by an admin.
// (admin sets driverDocs[type].verified === true via verifyDriverDoc)
export function areDocsVerified(profile) {
  const docs = (profile && profile.driverDocs) || {};
  return REQUIRED_DRIVER_DOCS.every(
    (k) => docs[k] && docs[k].verified === true
  );
}

// Profile-level eligibility for dispatch / customer driver-list.
// Callers add contextual checks (online/queue, location, car-type match).
export function isDriverEligible(profile) {
  return !!(
    profile &&
    profile.approved === true &&
    profile.driverActiveStatus === true &&
    areDocsVerified(profile)
  );
}
